import axios from "axios"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { errorMessage } from "../errors"
import { API_URL, serverError } from "../util"

const useUsers = userType => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [needRefetch, setNeedRefetch] = useState(true)

  useEffect(() => {
    setNeedRefetch(true)
  }, [userType])

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true)

      try {
        const resp = await axios.get(
          `${API_URL}/user/list?userType=${userType}`
        )
        const { status, message, users } = resp.data

        setLoading(false)
        if (status === "failed") return setError(errorMessage(message))

        setUsers(users)
      } catch (error) {
        setLoading(false)
        toast.error(serverError())
      }
    }

    if (needRefetch) {
      fetchUsers()
      setNeedRefetch(false)
    }
  }, [needRefetch, userType])

  const refetch = () => setNeedRefetch(true)

  return { users, loading, error, refetch }
}

export default useUsers
